export default {
  init: () => {
    document.querySelectorAll(".wysiwyg-article").forEach((el) => {
      el.querySelectorAll("img.leftAlone").forEach((img) => {
        const parent = img.closest("p");

        if (!parent || !parent.nextElementSibling) {
          return;
        }

        const siblingImg = parent.nextElementSibling.querySelector("img.rightAlone");

        if (siblingImg) {
          const siblingParent = siblingImg.closest("p");

          parent.classList.add("img-two-col");
          siblingParent.classList.add("img-two-col");
        }
      });

      el.querySelectorAll("ol li strong:first-child").forEach((li) => {
        li.closest("li").classList.add("marker-bold");
      });
    });
  },
};
